import React, { useEffect } from 'react';

export default function ForceLogout() {

  useEffect(() => {
    sessionStorage.clear();

    let dominioURL = 'one7';
    if (window && window.location.hostname !== 'localhost') {
      const hostnameParts = window.location.hostname.split('.');
      hostnameParts.shift();
      dominioURL = hostnameParts.join('.');
    }

    let urlPlataformaDigital = process.env.REACT_APP_LINK_PLATAFORMA_DIGITAL;
    urlPlataformaDigital = urlPlataformaDigital.replace('TENANT', dominioURL);
    window.location.replace(`${urlPlataformaDigital}/#/home`);
  }, []);

  return <div style={{ height: '1000px' }} />;
}
